var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    {
      staticClass:
        "c-list-component c-list-component--loading  c-competences-cards"
    },
    _vm._l(_vm.rowCount, function(n) {
      return _c(
        "tr",
        { key: n, staticClass: "c-list-row t-background-white" },
        [
          _vm._m(0, true),
          _vm._v(" "),
          _vm._m(1, true),
          _vm._v(" "),
          _vm._m(2, true)
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticClass: "c-list-item c-list-item--default c-list-item--loading" },
      [
        _c("span", { staticClass: "c-list-item__label c-list-item__label" }),
        _vm._v(" "),
        _c("p", { staticClass: "c-list-item__value" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticClass: "c-list-item c-list-item--default c-list-item--loading" },
      [
        _c("span", { staticClass: "c-list-item__label" }),
        _vm._v(" "),
        _c("p", { staticClass: "c-list-item__value" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticClass: "c-list-item t-text-align-right c-list-item--loading" },
      [_c("span", { staticClass: "c-list-item__action" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }